import type { RequestBody } from 'app/modules/RestorePassword/types';

import { httpApiService, ServiceResponse } from 'app/api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type DataFromBackend = any;

export const sendRequest = (
  url: string,
  data: Partial<RequestBody>,
): ServiceResponse<DataFromBackend> => (
  httpApiService.post(url, data)
);
